class BurgerMenu extends HTMLElement{
	constructor() {
		super()
		this.burgerButton = document.querySelector(".burger-button")
		this.body = document.querySelector("body")

		this.initBurgerMenu()
		this.initBurgerList()
	}

	initBurgerMenu() {
		this.burgerButton.addEventListener("click", () => {
			if (!this.body.classList.contains("burger-menu-open")) {
				this.open()
			} else {
				this.close()
			}
		})
	}

	initBurgerList() {
		const lists = this.querySelectorAll(".burger-menu_list-item")

		lists.forEach(listElement => {
			listElement.addEventListener("click", () => {
				const labelElement = listElement.querySelector(".burger-menu_list-item-label")

				if (!labelElement.classList.contains("open")) {
					this.openSubMenu(labelElement)
				} else {
					this.closeSubMenu(labelElement)
				}
			})
		})
	}

	open() {
		const screenWidth = window.innerWidth

		if (screenWidth < 567) {
			this.body.classList.remove("cart-drawer-show", "body-scroll-off", "backdrop-show")
		}

		this.body.classList.add("burger-menu-open", "body-scroll-off")
	}

	close() {
		this.body.classList.remove("burger-menu-open", "body-scroll-off")
	}

	openSubMenu(element) {
		element.classList.add("open")
	}

	closeSubMenu(element) {
		element.classList.remove("open")
	}
}

customElements.define("burger-menu", BurgerMenu)
